import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./GalleryHome.css";
import { Link } from "react-router-dom";
import { FaFilePdf, FaFileWord } from "react-icons/fa";

const API_ROOT = "https://purple-king-9edc.pandabitstudio.workers.dev";
const imageExt = ["jpg","jpeg","png","gif","webp","bmp","svg","heic","heif"];
const videoExt = ["mp4","webm","mov","mkv","avi"];
const audioExt = ["mp3","wav","aac","ogg","flac","m4a"];
const pdfExt = ['pdf'];
const wordExt  = ["doc","docx"];
const getExt   = k => (k.split(".").pop() || "").toLowerCase();

export default function GalleryHome() {
  const nav = useNavigate();
  const { search } = useLocation();
  const folder = new URLSearchParams(search).get("folder") || "";
  const pw = sessionStorage.getItem("password");
  const [keys, setKeys] = useState([]);
  const [error, setError] = useState("");
  const [idx, setIdx] = useState(null);

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  useEffect(() => {
    if (!pw) return;
    fetch(`${API_ROOT}/list?prefix=${encodeURIComponent(`uploads/${folder}/`)}`, {
      headers: { "X-Password": pw }
    })
      .then(r => r.json())
      .then(d => setKeys((d.keys || []).map(decodeURIComponent)))
      .catch(() => setError("Napaka pri branju datotek"));
  }, [pw, folder]);

  if (!pw) {
    return (
      <div className="Galleryupload-container">
        <p className="Gallerystatus-text">Not authorized</p>
        <button className="Gallerybtn" onClick={() => nav("/")}>Go to Login</button>
      </div>
    );
  }

  const files = [...keys].sort((a, b) => {
    const ea = getExt(a), eb = getExt(b);
    const oa = imageExt.includes(ea) ? 0 : videoExt.includes(ea) ? 1 : audioExt.includes(ea) ? 2 : 3;
    const ob = imageExt.includes(eb) ? 0 : videoExt.includes(eb) ? 1 : audioExt.includes(eb) ? 2 : 3;
    return oa - ob;
  });

  const downloadFile = async (url, name) => {
    const res = await fetch(url);
    const blob = await res.blob();
    const link = document.createElement("a");
    const obj  = URL.createObjectURL(blob);
    link.href = obj;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(obj);
  };


  return (
    <div className="Galleryupload-container">
      <center><Link to="/Onas/Podstrani/Login/Upload"><img src="/Slike/rc.png" className="cloudlogorc"/></Link></center> 
      <button className="Gallerybtn back-btn" onClick={() => nav("/Onas/Podstrani/Login/Upload")}>
        ← Nazaj
      </button>
      <h3 className="Galleryportalnaslov">MAPA: {folder}</h3>
      {error && <p className="Galleryerror-text">{error}</p>}
      <p className="Gallerygallery-count">Datoteke: ({files.length})</p>

      <div className="Galleryimages-grid">
        {files.map((k, i) => {
          const ext  = getExt(k);
          const url  = `${API_ROOT}/file/${encodeURIComponent(k)}`;
          const name = k.split("/").pop();
          const simpleTitle = name.replace(/^\d+-[0-9a-fA-F-]+-/, "");

          if (imageExt.includes(ext)) {
            return (
              <div key={k} className="Gallerythumb" onClick={() => setIdx(i)}>
                <img src={url} alt={name} loading="lazy" decoding="async"/>
                <button
                  className="Gallerydownload-btn"
                  onClick={e => { e.stopPropagation(); downloadFile(url, name); }}
                >
                  ⬇️ Prenesi
                </button>
              </div>
            );
          }

          if (videoExt.includes(ext)) {
            return (
              <div key={k} className="Gallerythumb video-thumb" onClick={() => setIdx(i)}>
                  <video
                  src={url}
                  muted
                  preload="metadata"
                  playsInline
                />
                <span className="Galleryplay-overlay">▶</span>
                <button
                  className="Gallerydownload-btn"
                  onClick={e => { e.stopPropagation(); downloadFile(url, name); }}
                >
                  ⬇️ Prenesi
                </button>
              </div>
            );
          }

          if (audioExt.includes(ext)) {
            return (
              <div key={k} className="Gallerythumb audio-thumb">
                <audio controls src={url}/>
                <button
                  className="Gallerydownload-btn"
                  onClick={e => { e.stopPropagation(); downloadFile(url, name); }}
                >
                  ⬇️ Prenesi
                </button>
              </div>
            );
          }

      // PDF
          if (pdfExt.includes(ext)) {
            return (
              <div key={k} className="Gallerythumb pdf-thumb">
                <FaFilePdf size={48} style={{ color: "#ff003c" }} />
                <span className="file-label">{simpleTitle}</span>
                <button className="Gallerydownload-btn"
                  onClick={e => { e.stopPropagation(); downloadFile(url, name); }}>
                  ⬇️ Prenesi
                </button>
              </div>
            );
          }

       // WORD
          if (wordExt.includes(ext)) {
            return (
              <div key={k} className="Gallerythumb word-thumb">
                <FaFileWord size={48} style={{ color: "#185abd" }} />
                <span className="file-label">{simpleTitle}</span>
                <button className="Gallerydownload-btn"
                  onClick={e => { e.stopPropagation(); downloadFile(url, name); }}>
                  ⬇️ Prenesi
                </button>
              </div>
            );
          }

          return (
            <div key={k} className="Gallerythumb other-thumb">
              <button className="Gallerydownload-btn" onClick={() => downloadFile(url, name)}>
                📄 {name}
              </button>
            </div>
          );
        })}
      </div>

      {idx !== null && (
        <div className="Gallerymodal-backdrop" onClick={() => setIdx(null)}>
          <button
            className="Gallerynav-btn"
            onClick={e => { e.stopPropagation(); setIdx(i => (i > 0 ? i - 1 : files.length - 1)); }}
          >
            ‹
          </button>

          <div className="Gallerymodal-body" onClick={e => e.stopPropagation()}>
            {/* NAZAJ button inside modal */}
            <button
              className="Galleryclose-btn"
              onClick={() => setIdx(null)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                padding: "0.5rem 1rem",
                background: "rgba(255,82,82,0.8)",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer"
              }}
            >
              NAZAJ
            </button>

            {(() => {
              const key = files[idx];
              const ext = getExt(key);
              const url = `${API_ROOT}/file/${encodeURIComponent(key)}`;
              const name = key.split("/").pop();

              if (imageExt.includes(ext)) return <img src={url} alt=""/>;
              if (videoExt.includes(ext)) return <video src={url} controls autoPlay/>;
              if (audioExt.includes(ext)) return <audio src={url} controls autoPlay />;
              return (
                <button className="Gallerydownload-btn" onClick={() => downloadFile(url, name)}>
                  ⬇️ {name}
                </button>
              );
            })()}
          </div>

          <button
            className="Gallerynav-btn"
            onClick={e => { e.stopPropagation(); setIdx(i => (i < files.length - 1 ? i + 1 : 0)); }}
          >
            ›
          </button>
        </div>
      )}
      <br></br>
      <br></br>
         <center>
        <p style={{color:"red"}}>-----------------------------------------</p>
        </center>
    </div>
  );
}